// @Core
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Resolvers
import { cancelOnboardingProcessResolver } from '../resolvers/cancel-drop-modal-footer.resolver';
// Types
import {
  CancelDropModalFooterBuilderHandlersType,
  CancelDropModalFooterMethodsHandlersType,
} from './types/cancel-drop-modal-footer.handlers.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const confirmDropOnboardingProcessButtonClick = async ({
  callbackUrl,
  clearAllSessionIntervalsProcesses,
  loanId,
  setLoading,
}: CancelDropModalFooterBuilderHandlersType): Promise<void> => {
  setLoading(true);

  await cancelOnboardingProcessResolver();

  clearAllSessionIntervalsProcesses();
  sessionUtils.clearSessionData();
  navigateToCallbackUrl({ callbackUrl, loanId });
};

const CancelDropModalFooterHandlers = (
  props: CancelDropModalFooterBuilderHandlersType
): CancelDropModalFooterMethodsHandlersType => ({
  handleConfirmDropOnboardingProcessButtonClick: () =>
    confirmDropOnboardingProcessButtonClick(props),
});

export { CancelDropModalFooterHandlers };
